import { PaginatedArrayService } from '~/services/serviceLivePaginatedArray'
import type {
  PrescriptionLine,
  PrescriptionLineStatus,
} from '~/models/PrescriptionLine'
import {
  documentId,
  getCountFromServer,
  limit,
  orderBy,
  query,
  where,
} from 'firebase/firestore'
import type { DateRange } from './interfaces/dateRange'

export class PrescriptionLineServicePaginated extends PaginatedArrayService<PrescriptionLine> {
  constructor() {
    super('PrescriptionLine')
  }

  public listenForStatusAndType(
    status: PrescriptionLineStatus[],
    types: string[],
    dateRange: DateRange,
    queryLimit: number = 20,
  ): void {
    let listenQuery = query(this.collection, where('Status', 'in', status))

    if (types.length > 0) {
      listenQuery = query(listenQuery, where('Type', 'in', types))
    }

    listenQuery = this.applyDateFilter(listenQuery, dateRange)

    listenQuery = query(
      listenQuery,
      orderBy('Created', 'desc'),
      limit(queryLimit),
    )

    this.listen(listenQuery)
  }

  public listenForId(prescriptionLineId: string, dateRange: DateRange): void {
    let listenQuery = query(
      this.collection,
      where(documentId(), '==', prescriptionLineId),
      limit(1),
    )

    listenQuery = this.applyDateFilter(listenQuery, dateRange)

    this.listen(listenQuery)
  }

  public async getCountByStatusAndType(
    status: PrescriptionLineStatus[],
    types: string[],
    dateRange: DateRange,
  ): Promise<number> {
    let countQuery = query(this.collection, where('Status', 'in', status))

    countQuery = this.applyDateFilter(countQuery, dateRange)

    if (types.length > 0) {
      countQuery = query(countQuery, where('Type', 'in', types))
    }

    const snapshot = await getCountFromServer(countQuery)
    return snapshot.data().count
  }
}
